export class xeroxSsoService {
  /* @ngInject */
  constructor(
    appSettings,
    commonService,
    sessionService,
    apiClientService,
    $http
  ) {
    this.appSettings = appSettings;
    this.commonService = commonService;
    this.sessionService = sessionService;
    this.apiClientService = apiClientService;
    this.$http = $http;
  }
  async getSignupModel(token) {
    const deviceSessionAccessData =
      await this.sessionService.getDeviceAuthSessionData();

    const result = await this.apiClientService.ssoPost("/login", {
      access: {
        value: deviceSessionAccessData.accessParams,
        status: "Success",
      },
      user: { value: deviceSessionAccessData.username, status: "Success" },
      token: "clio token",
      largeData: angular.toJson(token),
      appId: this.getCurrentSsoAppId(),
    });

    return result.model;
  }
  async getLoginModel() {
    const deviceSessionAccessData =
      await this.sessionService.getDeviceAuthSessionData();

    if (!deviceSessionAccessData) return null;

    const result = await this.apiClientService.ssoPost("/login", {
      access: {
        value: deviceSessionAccessData.accessParams,
        status: "Success",
      },
      user: { value: deviceSessionAccessData.username, status: "Success" },
      appId: this.getCurrentSsoAppId(),
    });

    return result.model;
  }
  async getRefreshModel(callbackData, token) {
    //if (!callbackData.token)
    callbackData.token = {};
    callbackData.token.message = "updated " + moment().format("HHMMSS");
    callbackData.token.largeData = angular.toJson(token);

    const refeshPostdata = {
      appId: this.getCurrentSsoAppId(),
      token: callbackData.token,
      sessionId: callbackData.sessionId,
      serverToken: callbackData.updatedAccessToken,
    };

    const refreshData = await this.apiClientService.ssoPost(
      "/refresh",
      refeshPostdata
    );
    const address = atob(callbackData.updatePath);
    try {
      const result = await this.$http.post(address, refreshData.model);
      return result.data;
    } catch (e) {
      return e;
    }
  }
  getCurrentSsoAppId() {
    const server = this.commonService.getCurrentSlot();
    let appIdSetting;
    appIdSetting = "ssoAppId";
    if (server)
      appIdSetting =
        "ssoAppId" + server.charAt(0).toUpperCase() + server.slice(1);
    return this.appSettings[appIdSetting];
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/xeroxSso.service.js